export default __webpack_public_path__ + "static/media/tenant-welt.6bfe2bec.svg";